import Api from "../ApiUtility/Api";


class AgenciesDS {
  constructor() {
    this.api = new Api();
  }

  //LOGIN POST

  AP_Agency_INSERT(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_INSERT')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  AP_Agency_List_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_List_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  AP_Dataset_List_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Dataset_List_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  AP_Agency_ById_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_ById_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  AP_Agency_UPDATE(requestData) 
  {
    return this.api.postAPI(requestData, '/dev/WS_Agency_UPDATE')
    .then(data => {
      console.log("parsed data", data)
      return data;
    })
    .catch(error => {
      console.error('Error during User Authentication API call :', error);
      throw error;
    });
  }

  WS_Agency_Bulk_INSERT(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Agency_Bulk_INSERT')
      .then(data => {
        console.log("Bulk insert response", data);
        return data;
      })
      .catch(error => {
        console.error('Error during Agency Bulk Insert API call :', error);
        throw error;
      });
  }

    WS_s3Key_By_Dataset_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_s3Key_By_Dataset_GET')
      .then(data => {
        console.log("s3 Key fetech by dataset", data);
        return data;
      })
      .catch(error => {
        console.error('Error during s3 jey fetch by dataset API call :', error);
        throw error;
      });
  }


  // RM_Activity_Logs_ByID_Get(requestData) {
  //   return this.api.postAPI(requestData, '/dev/RM_Activity_Logs_ByID_Get')
  //     .then(data => {
  //       console.log("parsed data", data)
  //       return data;
  //     })
  //     .catch(error => {
  //       console.error('Error during User Authentication API call :', error);
  //       throw error;
  //     });
  // }

}

export default AgenciesDS;